/**
 * Signed chip amount for round results: wins render "+50", losses render
 * "−25" (U+2212 minus), zero renders "0". Keeps win/loss display consistent
 * across the player phone and the host TV.
 */
export function formatSignedChips(amount: number): string {
  const abs = Math.abs(amount).toLocaleString();
  if (amount > 0) return `+${abs}`;
  if (amount < 0) return `−${abs}`;
  return '0';
}
